export default "__VITE_ASSET__DLaQJlT0__"